import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEditableContent } from "../../Context/EditableContentContext";
import ContractFormModal from "../ContractForm/ContractFormModal";

export default function GalleryTopHeader({ toggleSidebar }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const noHeader = pathname === "/gallery/settings" || pathname.startsWith("/gallery/settings/");
  const { editableGalleryContent, handleGalleryContentChange } = useEditableContent();
  const [isEditing, setIsEditing] = useState(false);
  const [newContent, setNewContent] = useState(editableGalleryContent);

  // Save the last Event page URL when navigating to Gallery
useEffect(() => {
  if (pathname === "/gallery" && !pathname.startsWith("/gallery/settings")) {
    // Assuming the previous page is the Event page
    const previousUrl = "/dashboard"; // Fallback to /dashboard if referrer is not available
      localStorage.setItem("lastEventUrl", previousUrl);
  }
}, [pathname]);

  const handleInputChange = (e) => setNewContent(e.target.value);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleGalleryContentChange(newContent);
      setIsEditing(false);
    }
  };

  const handleClick = () => setIsEditing(true);

  const handleBlur = () => {
    handleGalleryContentChange(newContent);
    setIsEditing(false);
  };

  const handleBackClick = () => {
    if (pathname === "/gallery/settings" || pathname.startsWith("/gallery/settings/")) {
      // Navigate to /gallery from settings pages
      navigate("/gallery");
    } else if (pathname === "/gallery") {
      // Navigate to the saved Event URL from gallery
      const lastEventUrl = localStorage.getItem("lastEventUrl") || "/dashboard";
      navigate(lastEventUrl);
    } else {
      // Default back navigation
      navigate(-1);
    }
  };

  return (
    <>
      <ContractFormModal />
      <nav className="navbar navbar-expand  flex-md-row bottom-header-main px-lg-5 px-2 py-2 align-items-center justify-content-between">
        <div className="d-flex align-items-center d-md-flex ms-md-2">
          <div className="d-flex align-items-center bottom-header">
            {/* Hamburger */}
            <button
              className="sidebar-toggler flex-shrink-0 bg-transparent border-0 me-3"
              onClick={handleBackClick}
            >
              <i className="fa fa-arrow-left" />
            </button>
            <p className="d-flex align-items-center">
              <span className="preview-text">Back</span>
            </p>
          </div>
        </div>

        {!noHeader && (
          <div className="navbar-nav align-items-center ms-md-auto">
            <div className="py-3 button_group gy-3">
              {/* Preview button */}
              <Link to="/gallery/view">
                <button className="mb-md-0 bg-white preview_btn">PREVIEW</button>
              </Link>
              {/* Publish button */}
              <button
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop01"
              >
                PUBLISH
              </button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}